import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { UserModuleAnswerExportType } from 'user/model/module/answer/user-module-answer-export.type';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface GenerateUserModuleAnswersInput {
	readonly userId: string;
	readonly splitByRelationship: boolean;
	readonly organizationModuleId: string;
	readonly userModuleAnswersExportType: UserModuleAnswerExportType;
}

export interface GenerateUserModuleAnswersParams {
	input: GenerateUserModuleAnswersInput;
}

@Injectable({ providedIn: 'root' })
export class GenerateUserModuleAnswersMutation extends ApiMutation<
	string,
	GenerateUserModuleAnswersParams
> {
	client = 'content';
	document = gql`
		mutation GenerateUserModuleAnswers($input: GenerateUserModuleAnswersInput!) {
			generateUserModuleAnswers(input: $input)
		}
	`;
	method = 'generateUserModuleAnswers';
}
